import type { ProviderOperationsSearchRowResponse } from "libs/apiClient";

/** Request ids are only unique per provider. */
export function getProviderOperationsRowKey(row: ProviderOperationsSearchRowResponse): string {
	return `${row.provider}:${row.id}`;
}
